module.exports = {"341525100":"衡山镇","341525101":"佛子岭镇","341525102":"下符桥镇","341525103":"但家庙镇","341525104":"与儿街镇","341525105":"黑石渡镇","341525106":"诸佛庵镇","341525107":"落儿岭镇","341525108":"磨子潭镇","341525109":"大化坪镇","341525110":"漫水河镇","341525111":"上土市镇","341525112":"单龙寺镇","341525201":"东西溪乡","341525202":"太平畈乡","341525203":"太阳乡","341525400":"经济开发区","341525401":"高桥湾现代产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341525.json
// module id = 1144
// module chunks = 0